import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instance28fytmsmm6r23 as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance3cean630pgfyb as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$DeepRecursiveFunction, it, $completion) {
  var tmp0_subject = $this.y2s_1.u2s_1.z2s();
  var tmp;
  if (tmp0_subject === 1) {
    tmp = readValue($this.y2s_1, true);
  } else if (tmp0_subject === 0) {
    tmp = readValue($this.y2s_1, false);
  } else if (tmp0_subject === 6) {
    var tmp_0 = readObject_0($this.y2s_1, $this$DeepRecursiveFunction, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else if (tmp0_subject === 8) {
    tmp = readArray($this.y2s_1);
  } else {
    $this.y2s_1.u2s_1.n2r("Can't begin reading element, unexpected token");
  }
  return tmp;
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.u2s_1.a2t(6);
  if ($this.u2s_1.z2s() === 4) {
    $this.u2s_1.n2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().gc();
  $l$loop: while ($this.u2s_1.b2t()) {
    var key = $this.v2s_1 ? $this.u2s_1.d2t() : $this.u2s_1.c2t();
    $this.u2s_1.a2t(5);
    var element = $this.e2t();
    // Inline function 'kotlin.collections.set' call
    result.c5(key, element);
    lastToken = $this.u2s_1.f2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.u2s_1.n2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.u2s_1.a2t(7);
  } else if (lastToken === 4) {
    if (!$this.w2s_1) {
      invalidTrailingComma($this.u2s_1);
    }
    $this.u2s_1.a2t(7);
  }
  return new (JsonObject())(result);
}
function *_generator_readObject__361wel($this, _this__u8e3s4, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.u2s_1.a2t(6);
  if ($this.u2s_1.z2s() === 4) {
    $this.u2s_1.n2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().gc();
  $l$loop: while ($this.u2s_1.b2t()) {
    var key = $this.v2s_1 ? $this.u2s_1.d2t() : $this.u2s_1.c2t();
    $this.u2s_1.a2t(5);
    var tmp = _this__u8e3s4.ws(Unit_instance, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var element = tmp;
    // Inline function 'kotlin.collections.set' call
    result.c5(key, element);
    lastToken = $this.u2s_1.f2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.u2s_1.n2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.u2s_1.a2t(7);
  } else if (lastToken === 4) {
    if (!$this.w2s_1) {
      invalidTrailingComma($this.u2s_1);
    }
    $this.u2s_1.a2t(7);
  }
  return new (JsonObject())(result);
}
function readObject_0($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readObject__361wel.bind(VOID, $this, _this__u8e3s4), $completion);
}
function readArray($this) {
  var lastToken = $this.u2s_1.f2t();
  if ($this.u2s_1.z2s() === 4) {
    $this.u2s_1.n2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().u2();
  while ($this.u2s_1.b2t()) {
    var element = $this.e2t();
    result.n2(element);
    lastToken = $this.u2s_1.f2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.u2s_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.r2m_1;
      if (!condition) {
        var tmp$ret$1 = 'Expected end of the array or comma';
        tmp0.n2r(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.u2s_1.a2t(9);
  } else if (lastToken === 4) {
    if (!$this.w2s_1) {
      invalidTrailingComma($this.u2s_1, 'array');
    }
    $this.u2s_1.a2t(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.v2s_1 || !isString) {
    tmp = $this.u2s_1.d2t();
  } else {
    tmp = $this.u2s_1.c2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.y2s_1 = this$0;
      }
      g2t($this$DeepRecursiveFunction, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$DeepRecursiveFunction, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.g2t(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.g2t($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.u2s_1 = lexer;
        this.v2s_1 = configuration.r2n_1;
        this.w2s_1 = configuration.d2o_1;
        this.x2s_1 = 0;
      }
      e2t() {
        var token = this.u2s_1.z2s();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.x2s_1 = this.x2s_1 + 1 | 0;
          if (this.x2s_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.x2s_1 = this.x2s_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.u2s_1.n2r('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
